import { render, staticRenderFns } from "./NewForm.vue?vue&type=template&id=7ec07747&scoped=true&"
import script from "./NewForm.vue?vue&type=script&lang=ts&"
export * from "./NewForm.vue?vue&type=script&lang=ts&"
import style0 from "./NewForm.vue?vue&type=style&index=0&id=7ec07747&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.4.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ec07747",
  null
  
)

component.options.__file = "NewForm.vue"
export default component.exports